export enum CUSTOM_REPORT_ACTION_TYPE {
    SET_CUSTOM_REPORT_STATE = 'SET_CUSTOM_REPORT_STATE',
    CALL_POST_CUSTOM_REPORT = 'CALL_POST_CUSTOM_REPORT',
    CALL_GET_CUSTOM_REPORTS = 'CALL_GET_CUSTOM_REPORTS',
    CALL_DOWNLOAD_CUSTOM_REPORT = 'CALL_DOWNLOAD_CUSTOM_REPORT',
}
